import { StateNode } from '@ansys-internal/awf-angular/store';

export class SelectedDriveCycleState implements StateNode<string> {
  key: string = 'selectedDriveCycle';
  defaultValue: () => string = () => '';
}
